<template>
  <div>
    <!-- searching  -->

    <div class="box box-success">
      <div
        class="box-header with-border"
        v-show="true"
        style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;"
      >
        <h3 class="box-title">{{ $t("search.title") }}</h3>
      </div>
      <div class="box-body">
        <div class="row" style="margin-bottom: 10px;">
          <!-- tu ngay -->
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <label>
                    <span style="margin-left:5px;display:inline-block;"
                      >{{ $t("search.date_from") }}:</span
                    >
                  </label>
                </div>
                <date-picker
                  :config="options"
                  :value="search.date_from"
                  v-model="search.date_from"
                ></date-picker>
              </div>
            </div>
          </div>

          <!-- den ngay -->
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <label>
                    <span style="margin-left:5px;display:inline-block;"
                      >{{ $t("search.date_to") }}:</span
                    >
                  </label>
                </div>
                <date-picker
                  :config="options"
                  :value="search.date_to"
                  v-model="search.date_to"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="input-group date">
              <div class="input-group-addon">
                <label style="margin:0;">
                  <span style="margin-left:5px;display:inline-block;"
                    >{{ $t("search.mailschedule") }}:</span
                  >
                </label>
              </div>
              <select class="form-control select2" v-model="selected">
                <option
                  v-for="(option, idx) in option_search_schedules"
                  :value="option.value"
                  :key="idx"
                  >{{ option.text }}</option
                >
              </select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="onSearchReceipt"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              {{ $t("search.search_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- searching  -->
    <b-table
      :per-page="perPage"
      :current-page="currentPage"
      :items="gridSMTPDataList"
      :fields="gridSMTPColumns"
      class="mt-3"
      style="height:100vh"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template #cell(content)="row">
        <span v-html="row.item.content"></span>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      align="right"
      size="sm"
      class="mt-0"
    ></b-pagination>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
// import moment from "moment"
// import utils from '@/lib/utils'

export default {
  name: "ManagementMenuMail",
  data() {
    return {
      gridSMTPDataList: [],
      currentPage: 1,
      totalRows: 1,
      perPage: 5,
      isLoading: false,
      selected: null,
      option_search_schedules: [
        {
          text: this.$t("search.yes"),
          value: "True"
        },
        {
          text: this.$t("search.no"),
          value: "False"
        }
      ],
      search: {
        date_from: null,
        date_to: null
      },
      options: {
        format: "YYYY-MM-DD"
      },
      gridSMTPColumns: [
        {
          key: "STT",
          label: "STT",
          class: "text-center"
        },
        {
          key: "subject",
          label: "mail_box.smtp.subject",
          class: "text-center"
        },
        {
          key: "content",
          label: "mail_box.smtp.content",
          class: "text-left",
          thStyle: "width:700px;"
        },
        {
          key: "mailschedule",
          label: "search.mailschedule",
          class: "text-left"
        },
        {
          key: "to",
          label: "mail_box.smtp.to",
          class: "text-center"
        },
        {
          key: "bcc",
          label: "mail_box.smtp.bcc",
          class: "text-center"
        }
      ]
    };
  },
  watch: {
    GET_LIST_EMAIL_HISTORY_AGENT_DATA: function() {
      this.gridSMTPDataList = [];
      this.GET_LIST_EMAIL_HISTORY_AGENT_DATA.forEach((element, idx) => {
        // let data = {
        //   STT: idx + 1,
        //   subject: subject,
        //   content: content,
        //   mailschedule: is_schedule,
        //   to: to,
        //   bcc: bcc
        // };
        // this.gridSMTPDataList.push(data);
      });
      this.totalRows = this.gridSMTPDataList.length;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_LIST_EMAIL_HISTORY_AGENT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_LIST_EMAIL_HISTORY_AGENT",
      "ON_SHOW_TOAST"
    ]),
    onSearchReceipt: function() {
      // const data = {
      //   params: {
      //     page: 1,
      //     date_from: this.search.date_from,
      //     date_to: this.search.date_to,
      //     is_schedule: this.selected
      //   }
      // };
      // this.isLoading = true;
      // this.GET_LIST_EMAIL_HISTORY_AGENT(data)
      //   .then(
      //     function() {
      //       this.isLoading = false;
      //     }.bind(this)
      //   )
      //   .catch(
      //     function(error) {
      //       this.isLoading = false;
      //       this.ON_SHOW_TOAST({
      //         message: error,
      //         styleType: "danger"
      //       });
      //     }.bind(this)
      //   );
    }
  },
  mounted() {
    // const data = {
    //   params: {
    //     page: 1
    //   }
    // };
    // this.GET_LIST_EMAIL_HISTORY_AGENT(data);
  },
  components: {
    loading: Loading,
    "date-picker": datePicker
  }
};
</script>

<style>
.page-item.disabled .page-link{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementMenuMail.vue